import classes from './Sizing.module.scss'
import TestImage from '../../../../assets/Sizing-Sample-Video.png'
import ChevronDown from '../../../../assets/icons/ChevronDown.svg';

export default function Sizing() {
  return (
    <div>
      <div className={classes.Header}>Sizing</div>
      <div className={classes.SubHeader}>Select Your Size</div>
      <div className={classes.SubHeaderTitle}>How to measure ?</div>
      <img src={TestImage} alt='how to measure size' className={classes.SizingVideo} />
      <div className={classes.ProductSizeSelectorInput}>
        <div className={classes.SizeGuideInputText}>
          <div>Select your size</div>
          <img src={ChevronDown} alt='chevron down' />
        </div>
      </div>
      <div className={classes.Save}>Save</div>
    </div>
  )
}
